import React from 'react';
import BoosterEnhancedCashSummaryView from './BoosterEnhancedCashSummaryView';
import { SESAME_CASH_BOOSTER_ENHANCED_1 } from 'types/sesameCash.constants';
import {
  canUserEnrollInCash,
  isCreditScoreAbove650,
  isCreditScoreBelow650,
  isEnrolledNotFunded,
  isNotEnrolled,
} from 'helpers/sesameCash.helpers';
import { useHistory } from 'react-router-dom';
import { useEventHandler } from 'hook/event.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';
import { useFlag } from 'hook/flag.hook';
import SesameCashCb20UpsellModuleController from 'partial/OfferManager/modules/SesameCashCb20Upsell/SesameCashCb20UpsellModuleController';
import { isNonControlVariationLoadedAndEnabled } from 'helpers/optimizely.helper';
import { CashBalanceModule } from 'partial/OfferManager/modules/CashBalance/CashBalanceModule';
import { useEnrolledCashAccount } from 'hook/cashEnrolledHelper.hook';
import {
  BUILDER_2_UNENROLLED_OVERVIEW,
  SESAME_CASH_UNENROLLED_OVERVIEW,
} from 'types/morph.pagePosition.constants';

const BoosterEnhancedCashSummary = props => {
  const history = useHistory();
  const eventHandler = useEventHandler();
  const cashFlag = useFlag('cash');
  const cb20GaWebFlag = useFlag('cb2_0_ga_web');
  const isCb20GaWebFlag = isNonControlVariationLoadedAndEnabled(cb20GaWebFlag);
  const enrolledState = useEnrolledCashAccount({
    sesameCashAccount: props.sesameCashAccount,
    eventHandler: eventHandler,
    userInfo: props.userInfo,
  });
  const notSegmentSixNotEnrolledOverviewConfig =
    cashFlag?.config
      ?.module_not_segment_six_cash_promo_unenrolled_overview_config ?? {};
  const notSegmentSixNotEnrolledConfig =
    cashFlag?.config?.module_not_segment_six_cash_promo_unenrolled_config ?? {};
  let options = {};

  if (canUserEnrollInCash(props.userInfo)) {
    if (
      props.cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1 ||
      props.isCashPage
    ) {
      if (props.isCashPage) {
        options = notSegmentSixNotEnrolledConfig;
      } else {
        //WEB1 or WEB3
        options = notSegmentSixNotEnrolledOverviewConfig;
      }
    } else {
      //WEB2
      options = notSegmentSixNotEnrolledOverviewConfig;
    }
  }

  const pixel = useSeenModulePixel(
    getViewModuleTrackingAttributes({
      pagePosition: options.moduleName,
      modulePosition: props.modulePosition,
      vertical: options.vertical,
    }),
  );
  const onClickCTA = () => {
    eventHandler(CLICK, {
      'Click Type': options?.clickType,
      'Module Name': options?.moduleName,
      Vertical: BANKING_VERTICAL,
    });
    if (canUserEnrollInCash(props.userInfo)) {
      history.push('/sesameCashEnrollment/enroll');
    } else {
      history.push('/cash/fundAccount');
    }
  };

  const onClickCtaLearnMore = moduleName => {
    if (props.isOverview) {
      const attr = {
        'Click Type': 'Learn More',
      };
      if (moduleName) {
        attr['Module Name'] = moduleName;
      }
      eventHandler(CLICK, attr);
      history.push('/cash');
    } else {
      props?.onClickCb20UpsellCta(moduleName);
    }
  };

  if (
    isCb20GaWebFlag &&
    props?.isOverview &&
    isNotEnrolled(props?.userInfo) &&
    isCreditScoreBelow650(props?.creditInfo)
  ) {
    return (
      <SesameCashCb20UpsellModuleController
        {...props}
        copyConfig={
          cb20GaWebFlag?.config?.module_unenrolled_user?.scoreBelow650Config
        }
        onCtaClick={() => {
          onClickCtaLearnMore(BUILDER_2_UNENROLLED_OVERVIEW);
        }}
      />
    );
  } else if (
    isCb20GaWebFlag &&
    props?.isOverview &&
    isNotEnrolled(props?.userInfo) &&
    isCreditScoreAbove650(props?.creditInfo)
  ) {
    return (
      <SesameCashCb20UpsellModuleController
        {...props}
        copyConfig={
          cb20GaWebFlag?.config?.module_unenrolled_user?.scoreAbove650Config
        }
        onCtaClick={() => {
          onClickCtaLearnMore(SESAME_CASH_UNENROLLED_OVERVIEW);
        }}
        imagePath={'/images/art-sesamecashdebitaccount.png'}
        isImageColumn={true}
        module_name={SESAME_CASH_UNENROLLED_OVERVIEW}
      />
    );
  } else if (
    isEnrolledNotFunded(props.userInfo, props.sesameCashAccount) &&
    !props.isCashPage
  ) {
    return <CashBalanceModule {...enrolledState} {...props} />;
  } else {
    if (Object.keys(options).length > 0) {
      return (
        <BoosterEnhancedCashSummaryView
          {...props}
          {...options}
          pixel={pixel}
          onClickCTA={onClickCTA}
        />
      );
    } else {
      return <></>;
    }
  }
};

export default BoosterEnhancedCashSummary;
